export const APP_STORE_LINKS = {
    DIRECT: "https://bbcmb.page.link/jfA2",
    QR_CODE: "https://bbcmb.page.link/VYPx",
    EMAIL_FROM_MOBILE: "https://bbcmb.page.link/ktWX",
    EMAIL_FROM_WEB: "https://bbcmb.page.link/7ghC"
};

export const STEP_NAMES = {
    APP_DOWNLOAD: "APP_DOWNLOAD",
    NEWSLETTER_SUBSCRIPTION: "NEWSLETTER_SUBSCRIPTION",
    FIRST_PARTY_DATA_COLLECTION: "FIRST_PARTY_DATA_COLLECTION",
    CONFIRMATION: "CONFIRMATION"
};

export const ONBOARDING_MINIMUM_TOTAL_STEPS = 4;
